export default {"src":"/_next/static/media/app_store.71414f28.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};